import { css, jsx } from '@emotion/core';
import { Divider } from 'antd';
import React, { PureComponent } from 'react';

import Form from '@/src/shared/components/Form';
import ReCaptchaFormItem from '@/src/shared/components/ReCaptchaFormItem';
import { bp, colors } from '@/styles';

import Card from './components/Card';
import FormButtons from './components/FormButtons';
import InputForm from './components/InputForm';
import StepIndicator from './components/StepIndicator';

class RegisterForm extends PureComponent {
  styles = {
    registerBackground: css`
      padding: 4rem 0 8rem;
      background-color: ${colors.accentGrayUltralight};
      @media ${bp.lg} {
        padding: 7.7rem 10rem;
      }
    `,
    card: css`
      margin: auto;
      max-width: 116.7rem;
    `,
    cardContent: css`
      padding: 0 16px;
      @media ${bp.md} {
        padding: 0;
      }
    `,
    cardTitle: css`
      font-size: 2rem;
      line-height: 1.6;
      margin: 0 0 1.6rem;
    `,
    cardSubtitle: css`
      font-size: 1.6rem;
      line-height: 1.75;
      padding: 0 3.2rem;
    `,
    disclaimer: css`
      font-size: 1.2rem;
      margin: auto;
      max-width: 56.9rem;
      padding: 0 16px 20px;
      @media ${bp.lg} {
        padding: 0 0 20px;
      }
    `,
    divider: css`
      margin: 2.4rem 0 2rem;
    `,
    captchaField: css`
      display: flex;
      flex-direction: column;
      align-items: center;
    `,
    staticContentContainer: css`
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 24px auto 0;
      max-width: 570px;
      text-align: center;
      p {
        margin-bottom: 0;
      }
      @media ${bp.md} {
        margin-top: 48px;
      }
    `,
    iconTextContainer: css`
      display: flex;
      flex-direction: row;
      margin-top: 20px;
      margin-bottom: 12px;
      align-items: center;
    `,
    sliderIcon: css`
      color: ${colors.secondaryBlue};
      margin: 0 4px;
      font-size: 1.8rem;
    `,
  };

  constructor(props) {
    super(props);
    this.state = {
      step: 0,
    };

    this.maxSteps = 2;
  }

  changeCurrentStep = step => this.setState({ step });

  render() {
    const { step } = this.state;
    const { fieldInfo, form, formTitle, formSubtitle } = this.props;

    return (
      <div>
        <Card
          containerStyle={this.styles.card}
          title={formTitle}
          titleStyle={this.styles.cardTitle}
          subTitle={formSubtitle}
          subTitleStyle={this.styles.cardSubtitle}
        >
          <div css={this.styles.cardContent}>
            <StepIndicator changeCurrentStep={this.changeCurrentStep} step={step} />
            <Form>
              <InputForm step={step} form={form} fieldInfo={fieldInfo} />
              {step !== this.maxSteps ? (
                ''
              ) : (
                <Form.Item label="" css={this.styles.captchaField}>
                  {form.getFieldDecorator('ReCaptcha', {
                    rules: [{ required: true, message: 'Check, checkbox.' }],
                  })(<ReCaptchaFormItem />)}
                </Form.Item>
              )}
              <FormButtons
                changeCurrentStep={this.changeCurrentStep}
                step={step}
                maxSteps={this.maxSteps}
                form={form}
              />
            </Form>
          </div>
          <Divider css={this.styles.divider} />
          <p css={this.styles.disclaimer}>
            By requesting a password to access information on the APCIA web site, you agree to use
            the information for your benefit and the benefit of your company only. APCIA information
            shall not be provided to any other person, firm or corporation without a mutually
            written agreement between yourself and the APCIA Public Affairs department.
          </p>
        </Card>
      </div>
    );
  }
}

export default Form.create({ name: 'RegistrationForm' })(RegisterForm);
